// extracted by mini-css-extract-plugin
export default {"submenu":"Submenu_submenu__1pQvg","open":"Submenu_open__y6v1r","freeform":"Submenu_freeform__rypjP","spin":"Submenu_spin__jnaE1","fadeInDown":"Submenu_fadeInDown__mPF12"};